export const INTRO_CONTROLLER_ID = 'Intro';
export const IMAGE_SLIDER_CONTROLLER_ID = 'ImageSlider';
export const MENU_CONTROLLER_ID = 'Menu';
